import * as React from 'react';
import { Route, RouteProps, useHistory } from 'react-router';
import { analytics, UNKNOWN_SCREEN, AnalyticsEventSource } from '@atlassian/temp-analytics';
import { GraphQLProvider } from '../../graphql-provider';
import { ProxyGraphClients } from '@atlassian/temp-client-utils';
import { initialize as initMetalClient } from '@atlassian/temp-metal/initialize';
import { hasAtleastOnePermission } from '../../security';

interface RouteWithAnalyticsProps extends RouteProps {
  source: AnalyticsEventSource;
  srcProxy?: string;
  allowedWithPermissions?: string[];
  metalId?: string;
}

/**
 * Wrapper for CASSI routes that handle analytics page setup / teardown
 * @param props
 */
const RouteWithAnalytics = (props: RouteWithAnalyticsProps) => {
  const { source, srcProxy = ProxyGraphClients.ANS, allowedWithPermissions, metalId, ...routeProps } = props;
  const history = useHistory();

  React.useEffect(() => {
    analytics.setGlobalPageProperties({
      source,
      pageAttributes: {},
    });
    initMetalClient(metalId);
    return () => {
      analytics.setGlobalPageProperties({
        source: UNKNOWN_SCREEN,
        pageAttributes: {},
      });
    };
  }, [source]);

  // check if user has access to the route
  if (allowedWithPermissions && !hasAtleastOnePermission(allowedWithPermissions)) {
    history.push('/unauthorized');
  }

  return (
    <GraphQLProvider srcClient={srcProxy}>
      <Route {...routeProps} />
    </GraphQLProvider>
  );
};

export default RouteWithAnalytics;
